import styled from "@emotion/styled";
import theme from "../../theme";
import { CustomTooltip } from "../common/CustomTooltip";
import { PhoneIcon, ShowPwIcon } from "../../assets/icons/icons";
import { maskPhoneNumber, textSubstring } from "../../utils/util";
import { useState } from "react";
import { DetectTodayResult, GetMobilityLive } from "../../types/types";
import AlertModal from "../alertModal";
import userStorage from "../../utils/userStorage";
import usePostContactRecord from "../../hooks/usePostContactRecord";
import { useWindowSize } from "@reactuses/core";
import { AlertModalInput } from "../alertModalInput";
import { useI18n } from "../../locales";
const { sm, md, lg } = theme.screen;

type Prop = {
  data?: GetMobilityLive | DetectTodayResult;
  currentLocation: string;
};

// 소유자 정보
export const CustomerInfo = ({ data, currentLocation }: Prop) => {
  const { width } = useWindowSize();
  const { t } = useI18n();
  const user = userStorage.get();
  const [showNum, setShowNum] = useState(false);
  // const [showNokNum, setShowNokNum] = useState(false);
  const [who, setWho] = useState(0);
  const [openPhoneModal, setOpenPhoneModal] = useState(false);
  const [name, setName] = useState("");
  const [visibleItems, setVisibleItems] = useState({
    item: "",
    phone: "",
  });

  const isLeased = data && !!data.lease_name; // 임차인 존재하는지 여부

  // 연락처 열람시 전달
  const { mutate: postContactRecord } = usePostContactRecord({
    mobility_seq: data?.seq as number,
    who,
    reader_name: name,
    admin_idx: user?.idx as number,
    showNum: () => setShowNum(true),
    // showNokNum: () => setShowNokNum(true),
    showNokNum: () => {},
    closeModal: () => setOpenPhoneModal(false),
    phone: visibleItems.phone,
    name: isLeased ? (data?.lease_name || "") : (data?.name || data?.owner || ""),
  });

  // 연락처 열람 모달에서 취소 클릭
  const onPressNo = () => {
    setOpenPhoneModal(false);
    setVisibleItems({
      item: "",
      phone: "",
    });
    setName("");
  };

  // 연락처 열람 모달에서 열람하기 클릭
  const onPressYes = () => {
    postContactRecord();
    setName("");
  };

  return (
    <>
      <WrapperStyledDiv>
        <TitleStyledH2>{t.control.ownerInfo}</TitleStyledH2>

        {/* 현재 위치 */}
        <InnerWrapperStyledDiv>
          <LeftSideStyledDiv>
            <CustomTooltip
              title={currentLocation}
              active={currentLocation.length > (width > lg ? 24 : 16)}
            >
              <TextWrapperStyledDiv>
                <TextSubTitleStyledSpan>{t.control.currentLocation}</TextSubTitleStyledSpan>
                <MainTextStyledSpan>
                  {textSubstring(currentLocation, 0, width > lg ? 24 : 16)}
                </MainTextStyledSpan>
              </TextWrapperStyledDiv>
            </CustomTooltip>

            {/* 소유자 이름 */}
            <CustomTooltip
              title={isLeased ? data.lease_name : data?.name}
              active={
                data &&
                (isLeased ? data.lease_name : data.name)?.length >
                  (width > lg ? 24 : 13)
              }
            >
              <TextWrapperStyledDiv>
                <TextSubTitleStyledSpan>{t.control.ownerLabel}</TextSubTitleStyledSpan>
                {isLeased
                  ? data.lease_name
                  : data?.name && (
                      <MainTextStyledSpan>
                        {textSubstring(
                          isLeased ? data.lease_name : data?.name,
                          0,
                          width > lg ? 24 : 13
                        )}
                      </MainTextStyledSpan>
                    )}
                {data?.owner && (
                  <MainTextStyledSpan>
                    {textSubstring(data?.owner, 0, width > lg ? 24 : 13)}
                  </MainTextStyledSpan>
                )}
              </TextWrapperStyledDiv>
            </CustomTooltip>

            {/* 소유자 연락처 */}
            <TextWrapperStyledDiv>
              <button
                onClick={() => {
                  if (!showNum) {
                    setVisibleItems({
                      item: t.control.ownerLabel,
                      phone: isLeased
                        ? data.lease_phone
                        : data?.phone ?? "",
                    });
                    setWho(1);
                    setOpenPhoneModal(true);
                  } else return;
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: showNum ? "default" : "pointer",
                }}
              >
                <TextSubTitleStyledSpan>
                  {t.control.ownerContact}
                </TextSubTitleStyledSpan>
                {!showNum && <ShowPwIcon />}
              </button>
              <MainTextStyledSpan>
                {data?.phone
                  ? showNum
                    ? data?.phone
                    : maskPhoneNumber(data.phone)
                  : ""}
              </MainTextStyledSpan>
            </TextWrapperStyledDiv>
          </LeftSideStyledDiv>

          {/* <RightSideStyledDiv>
          추가 알림 수신자 이름 
            <CustomTooltip
              title={data?.nok_name}
              active={
                data && data.nok_name?.length > (width > lg ? 24 : 13)
              }
            >
              <TextWrapperStyledDiv
                style={
                  data?.nok_name == null ? { marginBottom: "17px" } : {}
                }
              >
                <TextSubTitleStyledSpan>
                  추가 알림 수신자
                </TextSubTitleStyledSpan>
                <MainTextStyledSpan>
                  {textSubstring(data?.nok_name, 0, width > lg ? 24 : 13)}
                </MainTextStyledSpan>
              </TextWrapperStyledDiv>
            </CustomTooltip> 

            추가 알림 수신자 연락처
          <TextWrapperStyledDiv
              style={
                data?.nok_name == null ? { marginBottom: "17px" } : {}
              }
            >
              <div
                onClick={() => {
                  if (!showNokNum && data?.nok_phone) {
                    setVisibleItems({
                      item: "추가 알림 수신자",
                      phone: data?.nok_phone,
                    });
                    setWho(2);
                    setOpenPhoneModal(true);
                  } else return;
                }}
                style={
                  data?.nok_phone
                    ? {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: showNokNum ? "default" : "pointer",
                      }
                    : {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }
                }
              >
                <TextSubTitleStyledSpan>
                  추가 알림 수신자 연락처
                </TextSubTitleStyledSpan>
                {data?.nok_phone && <ShowPwIcon />}
              </div>
              <MainTextStyledSpan>
                {data?.nok_name != null
                  ? showNokNum
                    ? data?.nok_phone
                    : maskPhoneNumber(data.nok_phone)
                  : ""}
              </MainTextStyledSpan>
            </TextWrapperStyledDiv>

          추가 알림 수신자와 소유자 관계 
            <CustomTooltip
              title={data?.relation}
              active={
                data && data.relation?.length > (width > lg ? 24 : 13)
              }
            >
              <TextWrapperStyledDiv>
                <TextSubTitleStyledSpan>
                  추가 알림 수신자와 소유자 관계
                </TextSubTitleStyledSpan>
                <MainTextStyledSpan>
                  {textSubstring(data?.relation, 0, width > lg ? 24 : 13)}
                </MainTextStyledSpan>
              </TextWrapperStyledDiv>
            </CustomTooltip>
          </RightSideStyledDiv> */}
        </InnerWrapperStyledDiv>
      </WrapperStyledDiv>

      {/* 소유자/추가 알림 수신자 연락처 열람시 팝업되는 모달 */}
      <AlertModal
        open={openPhoneModal}
        onPressNo={onPressNo}
        title={t.control.contactViewConfirm}
        content={t.control.contactViewContent(visibleItems.item)}
        confirmText={t.control.contactViewButton}
        other={
          <AlertModalInput
            onChange={(e) => setName(e.target.value)}
            placeholder={t.control.contactViewPlaceholder}
            value={name}
          />
        }
        onPressYes={onPressYes}
        icon={<PhoneIcon />}
        otherFilled={Boolean(name.length)}
      />
    </>
  );
};

const WrapperStyledDiv = styled.div`
  background: ${theme.color.neutral_50};
  border: 3px solid ${theme.color.neutral_100};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 25px;

  @media (max-width: ${sm}px) {
    padding: 20px 10px 20px 10px;
  }

  @media (max-width: ${lg}px) {
    width: 100%;
    order: -1;
  }
  @media (min-width: ${lg + 1}px) {
    min-width: 417px;
    max-width: 417px;
  }

  @media print {
    order: 1;
    min-width: 417px;
    max-width: 417px;
  }
`;

const TitleStyledH2 = styled.h2`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  margin-bottom: 15px;

  @media (max-width: ${sm}px) {
    padding-left: 25px;
  }
`;

const InnerWrapperStyledDiv = styled.div`
  display: flex;
  flex: 1;
  gap: 30px;
  padding: 30px 0 20px 0;
  background: ${theme.color.white};
  border-radius: 20px;

  @media (min-width: ${lg + 1}px) {
    flex-direction: column;
    gap: 10px;
  }
  @media (max-width: ${sm}px) {
    gap: 10px;
  }

  @media print {
    flex-direction: column;
    gap: 10px;
  }
`;

const LeftSideStyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  flex: 1;
  /* border-right: 1px solid ${theme.color.neutral_200}; */
  padding-left: 20px;

  @media (max-width: ${sm}px) {
    padding-left: 10px;
  }
  @media (min-width: ${lg + 1}px) {
    /* gap: 10px; */
    gap: 40px;
    padding-left: 10px;
    border-right: none;
  }
  @media print {
    gap: 10px;
    padding-left: 10px;
    border-right: none;
  }
`;

// const RightSideStyledDiv = styled.div`
//   display: flex;
//   padding-left: 20px;
//   flex-direction: column;
//   gap: 25px;
//   flex: 1;

//   @media (max-width: ${sm}px) {
//     padding-left: 0px;
//   }
//   @media (min-width: ${lg + 1}px) {
//     gap: 10px;
//     padding-left: 10px;
//     border-right: none;
//   }
//   @media print {
//     gap: 10px;
//     padding-left: 10px;
//     border-right: none;
//   }
// `;

const TextWrapperStyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const TextSubTitleStyledSpan = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
`;

const MainTextStyledSpan = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.color.neutral_600};
  @media (max-width: ${sm}px) {
    font-size: 10px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    font-size: 11px;
  }
`;
